import * as React from 'react';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import { ErrorBoundary } from 'src/utils';

import { IBrand } from 'src/common/models/brand';
import { ICampaign } from 'src/common/models/campaign';
import { IOrganization } from 'src/common/models/organization';

import { initialState } from './redux/models';
import reducer from './redux/reducer';
import pageMiddlewares from './redux/middlewares';

import RecommendedPage, { IOwnProps } from './RecommendedPage';

interface IProps extends IOwnProps {
  // api endpoint
  apiEndpoint: string;

  org: IOrganization;
  brand: IBrand;
  campaign: ICampaign;
}

const { useMemo } = React;

/**
 * @type {React.FunctionComponent}
 */
const RecommendedPageWrapper: React.FunctionComponent<IProps> = React.memo((props) => {
  const {
    apiEndpoint,
    org,
    brand,
    campaign,
    ...restProps
  } = props;

  const store = useMemo(() => {
    const middlewares = [thunk, ...pageMiddlewares];

    // only use redux-logger in development
    if (process.env.NODE_ENV !== 'production') {
      const createLogger = require('redux-logger').createLogger;

      middlewares.push(createLogger());
    }

    return createStore(
      reducer,
      {
        ...initialState,
        apiEndpoint,
        org,
        brand,
        campaign,
      },
      compose(applyMiddleware(...middlewares)),
    );
  }, [apiEndpoint, org, brand, campaign]);

  return (
    <Provider store={store}>
      <ErrorBoundary>
        <RecommendedPage {...restProps} />
      </ErrorBoundary>
    </Provider>
  );
});

export default RecommendedPageWrapper;
